import $ from "jquery";
import { throttle } from "lodash";
import Hub from 'cartware-hub';

class Component {
	get hub() {
		return Hub.getInstance();
	}

	constructor() {
		if ("function" === typeof this.onResize) {
			$(window).on("resize", throttle(this.onResize.bind(this)));
		}

		if ("function" === typeof this.onScroll) {
			$(window).on("scroll", throttle(this.onScroll.bind(this)));
		}
	}
}

export default Component;
